import React from 'react';
import { useAppContext } from '../context/AppContext';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft } = FiIcons;

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-black uppercase tracking-widest mb-4" style={{ color: '#ff00cc', fontSize: '14px' }}>
      {title}
    </h2>
    <div className="space-y-3" style={{ color: '#9ca3af', fontSize: '15px', lineHeight: '1.75' }}>
      {children}
    </div>
  </div>
);

export default function TermsPage() {
  const { setCurrentPage } = useAppContext();

  return (
    <div className="min-h-screen" style={{ background: '#080012', fontFamily: 'Courier New, monospace', color: '#fff' }}>
      <div className="max-w-2xl mx-auto px-6 py-12 pb-24">
        <button onClick={() => setCurrentPage('home')}
          className="flex items-center gap-2 text-pink-500 hover:text-pink-300 transition-colors font-bold uppercase tracking-widest mb-10"
          style={{ fontSize: '13px' }}>
          <FiArrowLeft /> Back to Grid
        </button>

        <h1 className="font-black uppercase mb-2 leading-none"
          style={{ color: '#ff00cc', fontFamily: 'Impact,sans-serif', letterSpacing: '3px', fontSize: 'clamp(32px,6vw,56px)' }}>
          Terms of Service
        </h1>
        <p className="mb-10" style={{ color: '#4b5563', fontSize: '13px' }}>Last updated: January 2026</p>

        <Section title="1. Acceptance">
          <p>By purchasing pixels on this site you agree to these terms. If you do not agree, do not make a purchase.</p>
        </Section>

        <Section title="2. What You're Buying">
          <p>You are purchasing a permanent, non-transferable license to display your content in a defined region of the 1 Million Pixel Grid. This is a display license, not ownership of intellectual property or any underlying infrastructure.</p>
          <p>"Permanent" means your block will remain on the grid for the lifetime of this website. We commit to maintaining the grid indefinitely, but cannot guarantee infinite uptime.</p>
        </Section>

        <Section title="3. Content Rules">
          <p>You may not submit content that is illegal, pornographic, hateful, defamatory, or infringes third-party intellectual property rights. We reserve the right to remove any block that violates these rules without refund.</p>
          <p>You retain ownership of any original content you submit. By submitting it you grant us a perpetual, royalty-free license to display it on the grid.</p>
        </Section>

        <Section title="4. Payments & Refunds">
          <p>All sales are final. Prices are set per the published tier schedule and may increase as more pixels are sold. Your purchase locks in the price at the time of transaction.</p>
          <p>Payments are processed by Stripe. We do not store payment card details.</p>
        </Section>

        <Section title="5. Add-ons">
          <p>Optional add-ons (Glow border, Dofollow link, GIF support) are purchased at the time of checkout and applied to your block. Add-on fees are non-refundable.</p>
        </Section>

        <Section title="6. Limitation of Liability">
          <p>This service is provided "as is." We are not liable for any indirect, incidental, or consequential damages arising from your use of the grid or loss of display time due to downtime.</p>
        </Section>

        <Section title="7. Changes to Terms">
          <p>We may update these terms. Continued use of the site after changes constitutes acceptance. We will post the updated date at the top of this page.</p>
        </Section>

        <Section title="8. Contact">
          <p>Questions? Email <span style={{ color: '#ff00cc' }}>legal@1millionpixels.com</span></p>
        </Section>

        <div className="mt-8 pt-6 border-t border-pink-500/10">
          <button onClick={() => setCurrentPage('privacy')}
            className="text-sm font-bold transition-colors hover:text-pink-400"
            style={{ color: '#6b7280' }}>
            View Privacy Policy →
          </button>
        </div>
      </div>
    </div>
  );
}